import { useEffect, useState, createContext, useContext, useCallback } from "react";
import { api } from "@/lib/api";

const CurrencyContext = createContext(null);

const FALLBACK = {
  base_currency: "usd",
  rates: { usd: 1 },
  currencies: { usd: { symbol: "$", label: "US Dollar" } },
};

export const CurrencyProvider = ({ children }) => {
  const [config, setConfig] = useState(FALLBACK);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/currency");
      setConfig(data);
    } catch {}
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const symbol = (code) =>
    config.currencies?.[(code || config.base_currency).toLowerCase()]?.symbol || "$";

  const format = (amount, code) => {
    const cur = (code || config.base_currency).toLowerCase();
    const n = Number(amount || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${symbol(cur)}${n}`;
  };

  const toBase = (amount, code) => {
    const cur = (code || config.base_currency).toLowerCase();
    const base = (config.base_currency || "usd").toLowerCase();
    const rates = config.rates || {};
    const fx = Number(rates[base] || 1) / Number(rates[cur] || 1);
    return Number(amount || 0) * fx;
  };

  return (
    <CurrencyContext.Provider value={{ ...config, format, symbol, toBase, reload }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext) || { ...FALLBACK, format: (a) => `$${Number(a || 0).toFixed(2)}`, symbol: () => "$", toBase: (a) => Number(a || 0) };
